<div class="bg-white p-5">
  <!-- Header bar -->
  <div class="page-title">
    <h1 class="text-xl font-bold text-dc-navy">
      {{ "MY_DOCS.TITLE" | translate }}
    </h1>
  </div>

  <!-- Filter Bar -->
  <form [formGroup]="filterForm" class="page-filterbar">
    <div class="auto-width-dropdown w-full sm:w-72">
      <app-option-field
        label=""
        [placeholder]="'MY_APPS.FILTER.MEMBERSHIP' | translate"
        [options]="memberships"
        [labelKey]="'Name'"
        [valueKey]="'Value'"
        [control]="filterForm.get('membership')"
        (onSelectionChange)="filterByMembership($event)"
        [showSelectedTooltip]="true"
      >
      </app-option-field>
    </div>
    <div class="ms-auto w-full sm:w-60 pt-1.5">
      <div
        class="flex items-center border border-dc-navy text-dc-navy font-light overflow-hidden"
      >
        <input
          type="text"
          [placeholder]="'MY_DOCS.SEARCH' | translate"
          class="flex-grow px-4 py-2 text-sm focus:outline-none"
          formControlName="search"
          (keydown.enter)="search()"
          (keyup)="removeSearch($event)"
        />
        <button type="button" class="px-4 text-dc-navy" (click)="search()">
          <i class="fas fa-search"></i>
        </button>
      </div>
    </div>
  </form>

  <!-- Bulk-selection toolbar  -->
  @if (selectedIds.size) {
  <div
    class="flex items-center gap-4 bg-[#E5F6FF] text-dc-navy py-4 px-4 mb-2 mt-2"
  >
    <input
      type="checkbox"
      class="peer form-checkbox h-6 w-6 text-dc-navy border-dc-navy accent-dc-navy rounded-none"
      [checked]="allChecked()"
      (change)="toggleAll($event)"
    />
    <span class="font-semibold text-sm">
      {{ "MY_DOCS.SELECTED" | translate : { n: selectedIds.size } }}
    </span>
    <span class="ms-auto flex gap-5">
      <app-button
        classesName="card-edge-cut-white text-dc-navy"
        [label]="'MY_DOCS.DOWNLOAD' | translate"
        (onBtnClick)="download()"
      />
    </span>
  </div>
  }

  <!-- Documents Table -->
  <table class="dc-table">
    <thead>
      <tr class="text-left">
        @if(listOfDocuments && listOfDocuments.length>0){
        <th class="w-10">
          <input
            type="checkbox"
            class="peer form-checkbox h-6 w-6 text-dc-navy border-dc-navy accent-dc-navy rounded-none"
            [checked]="allChecked()"
            (change)="toggleAll($event)"
          />
        </th>
        }
        <th class="text-left!">{{ "MY_DOCS.COL.NAME" | translate }}</th>
        <th>{{ "MY_DOCS.COL.MEMBERSHIP" | translate }}</th>
        <th>{{ "MY_DOCS.COL.DATE" | translate }}</th>
      </tr>
    </thead>

    <tbody>
      @if (loader) { @for (_ of [].constructor(10); track $index) {
      <tr class="divide-x divide-slate-300 border-b border-slate-200">
        @for (__ of [].constructor(3); track $index) {
        <td class="p-4">
          <span
            class="block h-3 w-full rounded bg-slate-200 animate-pulse"
          ></span>
        </td>
        }
      </tr>
      } } @else { @for (document of paginatedDocuments; track document) {
      <tr class="border-b hover:bg-gray-50">
        <!-- checkbox -->
        <td class="w-10">
          <input
            type="checkbox"
            class="peer form-checkbox h-6 w-6 text-dc-navy border-dc-navy accent-dc-navy rounded-none"
            [checked]="selectedIds.has(document.documentId)"
            (change)="toggle(document.documentId, $event)"
          />
        </td>
        <!-- icon + name -->
        <td class="py-2 text-left!">
          @if (document.kind === 'folder') {
          <i class="fas fa-folder text-dc-navy me-2"></i>
          } @if (document.kind === 'file') {
          <i class="fas fa-file text-dc-navy me-2"></i>
          }
          {{ document.label }}
        </td>
        <td>{{ selectedMembershipName }}</td>
        <td>{{ document.uploadedDate }}</td>
      </tr>
      } } @if (!loader && (!listOfDocuments || listOfDocuments.length < 1)) {
      <tr>
        <td class="text-center! py-4 text-dc-gray-light italic" colspan="3">
          {{ "NO_RECORD_FOUND" | translate }}
        </td>
      </tr>
      }
    </tbody>
  </table>
  @if (!loader && totalPages > 1) {
  <div class="flex justify-center">
    <app-pagenation
      [showInfo]="false"
      [data]="{
        currentPage: currentPage,
        totalPages: totalPages,
        totalItems: totalRecords
      }"
      (pageChangeEvent)="goToPage($event)"
    ></app-pagenation>
  </div>
  }
</div>
